import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthFn = /* @__PURE__ */ createRecipe('calendar-month', {}, [])

const calendarMonthVariantMap = {}

const calendarMonthVariantKeys = Object.keys(calendarMonthVariantMap)

export const calendarMonth = /* @__PURE__ */ Object.assign(memo(calendarMonthFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonth',
  __getCompoundVariantCss__: calendarMonthFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthVariantKeys,
  variantMap: calendarMonthVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthVariantKeys)
  },
  getVariantProps: calendarMonthFn.getVariantProps,
})